// middleware/auth.ts
// Used for guarding restricted pages.
import { useCarbarAuAuthStore } from '@/stores/carbar-au-auth'

// The API session is checked once per page load, in the browser
let isSessionChecked = false

export default defineNuxtRouteMiddleware(async (to) => {
	const authStore = useCarbarAuAuthStore()

	if (authStore.isLoggedIn && import.meta.client && !isSessionChecked) {
		isSessionChecked = true
		await authStore.verifySession()
	}

	// If already authenticated, allow passage
	if (authStore.isLoggedIn) {
		return
	}

	const targetUrl = encodeURIComponent(to.fullPath)
	const redirectedLoginUrl = `/secure/login?_redirect=${targetUrl}`

	return navigateTo(redirectedLoginUrl, {
		external: true,
	})
})
